export default function selectCurrentSearchTerm(state) {
  return state.location.payload.term || null
}
